import { StateObj } from 'src/types'

export const hamidashiOfNormal = (
  ctx: CanvasRenderingContext2D,
  hamidashiColor: string,
  leatherIntegratedMiddle: StateObj,
  middleFingerLeatherColor: string,
  isSUN01W: boolean,
  littleRingLeatherColor: string
): void => {
  const isLeatherIntegratedMiddle = leatherIntegratedMiddle?.value === 'atMiddleFinger'

  ctx.lineWidth = 0.8
  ctx.strokeStyle = '#282828'
  ctx.fillStyle = hamidashiColor
  if (isSUN01W) {
    ctx.beginPath()
    ctx.moveTo(215, 153) // 小指先端左
    ctx.quadraticCurveTo(195, 291, 211, 358) // 小指末端左
    ctx.quadraticCurveTo(213, 363, 214, 358) // 小指末端右
    ctx.quadraticCurveTo(200, 274, 220, 148) // 小指先端右
    ctx.quadraticCurveTo(215, 153, 215, 153) // 小指先端左
    ctx.fill()
    ctx.stroke()
    ctx.closePath()

    ctx.beginPath()
    ctx.fillStyle = littleRingLeatherColor
    ctx.moveTo(211, 358)
    ctx.quadraticCurveTo(230, 484, 320, 588) // 小指末端左
    ctx.quadraticCurveTo(324, 590, 324, 588) // 小指末端右
    ctx.quadraticCurveTo(235, 484, 215, 363) // 小指先端右
    ctx.quadraticCurveTo(211, 358, 211, 358) // 小指先端左
    ctx.fill()
    ctx.closePath()
    ctx.fillStyle = hamidashiColor
  } else {
    ctx.beginPath()
    ctx.moveTo(215, 153) // 小指先端左
    ctx.quadraticCurveTo(167, 410, 320, 590) // 小指末端左
    ctx.quadraticCurveTo(324, 590, 324, 590) // 小指末端右
    ctx.quadraticCurveTo(170, 400, 220, 149) // 小指先端右
    ctx.quadraticCurveTo(215, 153, 215, 153) // 小指先端左
    ctx.fill()
    ctx.stroke()
    ctx.closePath()
  }

  ctx.beginPath()
  ctx.moveTo(241, 313) // 小指薬指の間先端
  ctx.quadraticCurveTo(248, 375, 273, 427) // 小指薬指の間末端左
  ctx.quadraticCurveTo(277, 427, 277, 427) // 小指薬指の間末端右
  ctx.quadraticCurveTo(253, 375, 243, 313) // 小指薬指の間先端右
  ctx.quadraticCurveTo(241, 313, 241, 313) // 小指薬指の間先端左
  ctx.fill()
  ctx.stroke()
  ctx.closePath()

  // 薬指＿中央
  ctx.beginPath()
  ctx.moveTo(275, 92) // 薬指先端＿左
  ctx.quadraticCurveTo(236, 256, 294, 400) // 薬指末端＿左
  ctx.quadraticCurveTo(297, 400, 298, 400) // 薬指末端＿右
  ctx.quadraticCurveTo(240, 250, 279, 90) // 薬指先端＿右
  ctx.quadraticCurveTo(279, 90, 275, 92) // 薬指末端＿左
  ctx.fill()
  ctx.stroke()
  ctx.closePath()

  // 薬指中指の間
  ctx.beginPath()
  ctx.moveTo(305, 262) // 先端＿左
  ctx.quadraticCurveTo(304, 322, 317, 382) // 末端＿左
  ctx.quadraticCurveTo(322, 382, 322, 382) // 末端＿右
  ctx.quadraticCurveTo(308, 322, 308, 262) // 先端＿右
  ctx.quadraticCurveTo(305, 262, 305, 262) // 先端＿左
  ctx.fill()
  ctx.stroke()
  ctx.closePath()

  // 中指中央
  ctx.beginPath()
  ctx.moveTo(373, 37) // 中指先端＿左
  ctx.quadraticCurveTo(311, 190, 338, 368) // 中指末端＿左
  ctx.quadraticCurveTo(343, 368, 343, 368) // 中指末端＿右
  ctx.quadraticCurveTo(315, 190, 377, 37) // 中指先端＿右
  ctx.quadraticCurveTo(373, 37, 373, 37) // 中指先端＿右
  ctx.fill()
  ctx.stroke()
  ctx.closePath()
  if (isLeatherIntegratedMiddle) {
    ctx.fillStyle = middleFingerLeatherColor
    ctx.beginPath()
    ctx.moveTo(326, 154) // 左上
    ctx.quadraticCurveTo(311, 212, 317, 288) // 左下
    ctx.quadraticCurveTo(337, 297, 360, 280) // 右下
    ctx.quadraticCurveTo(351, 210, 368, 149) // 右上
    ctx.quadraticCurveTo(345, 137, 326, 154) // 左上
    ctx.fill()
    ctx.closePath()
    ctx.fillStyle = hamidashiColor
  }

  // 人差し指＿中央
  ctx.beginPath()
  ctx.moveTo(513, 20) // 先端＿左
  ctx.quadraticCurveTo(426, 157, 402, 356) // 末端＿左
  ctx.quadraticCurveTo(406, 356, 407, 356) // 末端＿右
  ctx.quadraticCurveTo(432, 157, 516, 20) // 先端＿右
  ctx.quadraticCurveTo(514, 20, 513, 20) // 先端＿左
  ctx.fill()
  ctx.stroke()
  ctx.closePath()

  // 親指
  ctx.beginPath()
  ctx.moveTo(737, 279) // 上_左
  ctx.quadraticCurveTo(619, 401, 562, 556) // 下_左
  ctx.quadraticCurveTo(568, 550, 569, 550) // 下_右
  ctx.quadraticCurveTo(625, 401, 739, 283) // 上_右
  ctx.quadraticCurveTo(737, 279, 737, 279) // 上_左
  ctx.fill()
  ctx.stroke()
  ctx.closePath()
}
